/* tslint:disable */
export var icon = "\n<svg width=\"17\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 8a8 8 0 11-16 0 8 8 0 0116 0zm-7-1v5h-2V7h2zm-2-1V4h2v2h-2z\" fill=\"#FB7D33\"/></svg>\n";
//# sourceMappingURL=warning-info.svg.js.map